import React from "react";

import { Icon, IconProps } from "../";

export const YqbSilhouetteIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2262 3.4835C20.1082 3.2791 19.8131 3.2791 19.6951 3.4835L19.0392 4.85761C18.4084 4.73323 17.7581 4.73335 17.1273 4.85774L16.4714 3.4835C16.3534 3.2791 16.0583 3.2791 15.9403 3.4835L14.6702 6.14422C14.6615 6.15253 14.6528 6.16066 14.6441 6.16878C14.6317 6.18035 14.6193 6.19189 14.6072 6.20395L12 8.81121L9.39265 6.20395C7.47269 4.284 4.35992 4.284 2.43996 6.20395L2.26559 6.38737C0.521887 8.3173 0.580011 11.2968 2.43996 13.1568L5.04722 15.764L12 8.8115L15.4763 12.2877C16.9163 13.7275 17.2763 15.8386 16.5563 17.614C16.4797 17.7773 16.7499 17.962 16.9268 17.7899L21.56 13.1568C23.42 11.2968 23.4781 8.3173 21.7344 6.38737L21.56 6.20395L21.4958 6.14287L20.2262 3.4835ZM9.7192 18.2046L7.4011 15.9389C7.09334 15.6328 6.59581 15.632 6.28964 15.9405C5.98311 16.2474 5.98385 16.7446 6.29075 17.0515L8.61352 19.3217C9.45679 20.1496 10.7094 20.6699 12.0234 20.6699C13.0795 20.6699 14.1745 20.3338 15.129 19.5512C15.4643 19.2757 15.5126 18.78 15.2379 18.4447C14.9617 18.1102 14.4684 18.0603 14.1315 18.3357C12.5236 19.6562 10.5813 19.0509 9.7192 18.2046Z"
      />
    </Icon>
  );
};
